// Captures the `beforeinstallprompt` event Chrome fires when the app meets
// its installability criteria (manifest + controlling service worker).
// Must be wired up at module load, before any component asks about it —
// the event only fires once and isn't replayed.

let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach(cb => cb(true));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach(cb => cb(false));
  });
}

export function isStandalone() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(display-mode: standalone)').matches
    || window.navigator.standalone === true; // iOS Safari
}

export function installAvailable() {
  return !!deferredPrompt;
}

// Fires with true/false whenever install availability changes.
export function onInstallAvailabilityChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

// Must be called from a user gesture (e.g. a button click).
export async function promptInstall() {
  if (!deferredPrompt) return { ok: false, reason: 'unavailable' };
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return { ok: outcome === 'accepted', reason: outcome };
}
